const initialState = {
  show: false,
  type: null,
  title: null,
  content: null,
  okText: null,
  cancelText: null,
  onOk: null,
  onCancel: null,
  name: null,
  isInstructionModal: false,
  queue: [],
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_MODAL':
      const modalName = action.payload.name;
      const isAlreadyShowing = state.show && state.name === modalName;
      const isInQueue = state.queue.some(modal => modal.name === modalName);

      if (isAlreadyShowing || isInQueue) {
        return state;
      }

      if (state.show) {
        return {
          ...state,
          queue: [...state.queue, action.payload],
        };
      } else {
        return {
          ...state,
          show: true,
          type: action.payload.type,
          title: action.payload.title,
          content: action.payload.content,
          okText: action.payload.okText,
          cancelText: action.payload.cancelText,
          onOk: action.payload.onOk,
          onCancel: action.payload.onCancel,
          name: action.payload.name,
          isInstructionModal: action.payload.isInstructionModal || false,
        };
      }
    case 'CLEAR_MODAL':
      if (state.queue.length > 0) {
        const nextModal = state.queue[0];
        return {
          ...state,
          show: true,
          type: nextModal.type,
          title: nextModal.title,
          content: nextModal.content,
          okText: nextModal.okText,
          cancelText: nextModal.cancelText,
          onOk: nextModal.onOk,
          onCancel: nextModal.onCancel,
          name: nextModal.name,
          isInstructionModal: nextModal.isInstructionModal || false,
          queue: state.queue.slice(1),
        };
      } else {
        return initialState;
      }
    default:
      return state;
  }
};

export default modalReducer;
